"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseWeekdayValue = exports.parseMonthValue = exports.parseTimeValue = exports.parseDateValue = exports.matchesTimePattern = exports.matchesDatePattern = void 0;
const value_1 = require("../value");
const const_1 = require("./const");
const validator_1 = require("./validator");
const DATE_PATTERN = /^(\d+)-(\d{2})-(\d{2})$/;
const TIME_PATTERN = /^(\d{2}):(\d{2}):(\d{2})$/;
const matchesDatePattern = (input) => DATE_PATTERN.test(input);
exports.matchesDatePattern = matchesDatePattern;
const matchesTimePattern = (input) => TIME_PATTERN.test(input);
exports.matchesTimePattern = matchesTimePattern;
const parseDateValue = (input) => {
    const result = DATE_PATTERN.exec(input);
    if (result == null) {
        throw new SyntaxError("Given date literal does not contain valid date.");
    }
    const year = parseInt(result[1]);
    const month = parseInt(result[2]);
    const day = parseInt(result[3]);
    if (month < 1 || month > 12 || !(0, validator_1.isValidDate)(year, month - 1, day)) {
        throw new SyntaxError("Given date literal does not contain valid date.");
    }
    return {
        type: "Date",
        year,
        month: month - 1,
        day,
    };
};
exports.parseDateValue = parseDateValue;
const parseTimeValue = (input) => {
    const result = TIME_PATTERN.exec(input);
    if (result == null) {
        throw new SyntaxError("Given time literal does not contain valid time.");
    }
    const hour = parseInt(result[1]);
    const minute = parseInt(result[2]);
    const second = parseInt(result[3]);
    if (!(0, validator_1.isValidTime)(hour, minute, second)) {
        throw new SyntaxError("Given time literal does not contain valid time.");
    }
    return (0, value_1.newTimeValue)(hour, minute, second);
};
exports.parseTimeValue = parseTimeValue;
const parseMonthValue = (input) => {
    const value = const_1.MONTH_NAME_MAPPING.get(input);
    if (value == null) {
        throw new SyntaxError(`Unrecognized month: ${input}`);
    }
    return {
        type: "Month",
        value,
    };
};
exports.parseMonthValue = parseMonthValue;
const parseWeekdayValue = (input) => {
    const value = const_1.WEEKDAY_NAME_MAPPING.get(input);
    if (value == null) {
        throw new SyntaxError(`Unrecognized weekday: ${input}`);
    }
    return {
        type: "Weekday",
        value,
    };
};
exports.parseWeekdayValue = parseWeekdayValue;
